/** @format */

import { TLocale } from '@/utils/gatsby/types';
import { TOtherPaths } from '../../@ducks/general/declarations';
import { utilityGetCurrentURL } from './getCurrentURL';

export const utilityGetLocaleURL = (locale: TLocale, otherPaths: TOtherPaths) => {
  const url = utilityGetCurrentURL({ locale, otherPaths });
  const parsedURL = url.includes('undefined') ? '/' : url;
  const isBrowser = typeof window !== 'undefined';
  const location: any = isBrowser ? window.location : '';
  const isLocalHost = location && location.hostname === 'localhost';
  const isHomePage = parsedURL === `/${locale}/`;
  if (isLocalHost && isHomePage) return `${origin}${parsedURL}`;
  if (isLocalHost) return `${origin}/${locale}${parsedURL}`;
  const isProduction = process.env.GATSBY_ENV === 'production';
  const isStaging = process.env.GATSBY_ENV === 'staging';
  const basePath = isProduction
    ? 'coliving.joivy.com'
    : isStaging
    ? 'test-coliving.joivy.com'
    : 'dev-coliving.joivy.com';

  if (isHomePage) return `https://${basePath}${parsedURL}`;
  return `https://${basePath}/${locale}${parsedURL}`;
};
